import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  const items = ['PDF eBook completo con instrucciones paso a paso', 'Lista de verificación para identificar los patrones de despertares nocturnos', 'Hoja de trabajo para evaluar métodos anteriores', 'El marco del Método de Micro-pausas con sus tres fases detalladas', 'Lista de verificación del entorno óptimo de sueño', 'Guía horaria detallada para las primeras 24 horas', 'Tablas de ajuste por edad (0-3 meses, 4-7 meses, 8-12 meses)', 'Lista de verificación de ajustes mensuales', 'Bonus: Mini-guía de audio con afirmaciones calmantes para la madre', 'Bonus: Plantilla imprimible de registro de sueño del bebé'];
  return <section className="py-20" data-id="element-303">
      <div className="max-w-4xl mx-auto px-6" data-id="element-304">
        <FadeIn data-id="element-305">
          <div className="text-center mb-16" data-id="element-306">
            <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-4" data-id="element-307">
              ¿Qué incluye la guía?
            </h2>
            <p className="text-lg text-brown/80 font-serif" data-id="element-308">
              Todo lo que necesitas para recuperar tus noches, paso a paso.
            </p>
          </div>
        </FadeIn>

        <div className="bg-white rounded-3xl shadow-soft p-8 md:p-12 border border-cream-dark" data-id="element-309">
          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-310">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.05} direction="up" data-id="element-311">
                <li className="flex items-start gap-4" data-id="element-312">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center mt-1" data-id="element-313">
                    <Check className="w-4 h-4 text-brown" data-id="element-314" />
                  </div>
                  <span className={item.includes('Bonus:') ? 'text-brown-dark font-bold' : 'text-brown-dark/80'} data-id="element-315">
                    {item}
                  </span>
                </li>
              </FadeIn>)}
          </ul>
        </div>
      </div>
    </section>;
}